// Ce que l'app dit a quelqu'un de connecte qui ne trouve pas son acces.
//
// Trois regles tenues ici, une seule fois, parce que deux surfaces les affichent
// (le verrou et la section Account des Settings) et qu'elles doivent dire
// exactement la meme chose :
//
//  - on ne presume jamais qu'un rachat existe deja ("If you got an access
//    code", pas "your code") ;
//  - on ne nomme jamais le site, et on n'offre aucun champ de code : l'app
//    constate, elle ne debloque pas (App Store 3.1.1) ;
//  - on nomme l'adresse du compte, parce que le seul vrai malentendu est de
//    s'etre connecte avec un autre compte que celui qui porte l'acces.
//
// Le relais Apple merite sa propre phrase : l'adresse affichee ne ressemble a
// rien de connu de l'utilisateur, la lui montrer ne l'aiderait pas a comprendre
// qu'il s'est trompe de compte.

export const APPLE_RELAY_DOMAIN = '@privaterelay.appleid.com';

export const ACCESS_ENDED_MESSAGE = 'Your access has ended.';

export const APPLE_RELAY_MESSAGE =
  'You signed in with Apple using a hidden address. Sign in with the account you used to activate your access.';

export function noAccessMessageFor(email) {
  return `No access on this account (${email}). If you got an access code, activate it first, then sign in here with that same account.`;
}

// Adresse de relais Apple ("Hide My Email") : le compte porte une boite
// jetable @privaterelay.appleid.com, jamais l'adresse reelle de la personne.
export function isApplePrivateRelayEmail(email) {
  if (typeof email !== 'string') return false;
  return email.trim().toLowerCase().endsWith(APPLE_RELAY_DOMAIN);
}

// Message a afficher a un compte connecte qui n'a pas d'acces, ou null quand il
// n'y a rien a dire (pas de compte, donc pas d'adresse a nommer).
//
// `status` est le dernier { found, active } rendu par /api/promo/mine pour ce
// compte. `found` avec `active` explicitement faux est le seul cas ou le serveur
// affirme quelque chose : une invitation existe bien pour ce compte, et elle ne
// vaut plus. Il passe donc avant le relais Apple, qui n'est qu'une hypothese sur
// la cause.
//
// Le test porte sur `active === false` et pas sur `!active` : un champ absent
// n'est pas une reponse, c'est un serveur qui n'a pas repondu a la question, et
// annoncer une fin d'acces la-dessus serait faux au pire moment. Le serveur
// actuel envoie toujours les deux champs (routes.js:337-350), la garde vaut donc
// pour une reponse tronquee ou un serveur plus ancien.
export function accessMessage({ email, status } = {}) {
  if (status?.found && status.active === false) return ACCESS_ENDED_MESSAGE;
  const address = typeof email === 'string' ? email.trim() : '';
  if (!address) return null;
  if (isApplePrivateRelayEmail(address)) return APPLE_RELAY_MESSAGE;
  return noAccessMessageFor(address);
}
